import { render, staticRenderFns } from "./FullComment.vue?vue&type=template&id=2d047980&"
import script from "./FullComment.vue?vue&type=script&lang=js&"
export * from "./FullComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports